export default __webpack_public_path__ + "static/media/351731.3e3f5fe8.jpg";